/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import AssetApi from "@/services/Asset";

export default {
	state: {
		libraryAssets: {
			assetType: null,
			data: [],
			loaded: true,
		},
		updatedLibraryAssets: [],
		recentlySearched: []
	},

	getters: {
		getLibraryAssets: (state) => () => {
			return state.libraryAssets;
		},

		getRecentlySearched: (state) => () => {
			return state.recentlySearched;
		},

		getUpdatedLibraryAssets: (state) => () => {
			return state.updatedLibraryAssets;
		}
	},

	mutations: {
		LIBRARY_ASSETS_REQUEST(state) {
			state.libraryAssets.data = [];
			state.libraryAssets.loaded = false;
		},

		LIBRARY_ASSETS_SUCCESS(state, payload) {
			state.libraryAssets.data.push(...payload.data);
			state.libraryAssets.loaded = true;
		},

		LIBRARY_ASSETS_FAILURE(state) {
			state.libraryAssets.data = [];
			state.libraryAssets.loaded = true;
		},

		UPDATE_LIBRARY_ASSET(state, {assetId, data}) {
			let assets = state.libraryAssets.data;
			let asset = assets.find(a => a.AssetID === assetId);
			assets.splice(assets.indexOf(asset), 1, {...asset, ...data});
		},

		setLibraryAssetsPosition(state, assets) {
			state.libraryAssets.data = assets;
		},

		setRecentlySearched(state, item) {
			const index = state.recentlySearched.indexOf(item);
			if (index === 0) {    //item is already at the 1st place
				return;
			}

			if (state.recentlySearched.length === 15 || index > -1) {      //(maxLength - 1) or we can use index === 15
				state.recentlySearched.splice(index, 1);
			}

			state.recentlySearched.unshift(item);
		},

		setUpdatedLibraryAssets(state, assetId) {
			let assets = state.updatedLibraryAssets.length > 0 ? state.updatedLibraryAssets : state.libraryAssets.data;
			let asset = assets.find(a => a?.AssetID === assetId);
			let updatedLibraryAssets = assets.toSpliced(assets.indexOf(asset), 1);
			updatedLibraryAssets.unshift(asset);
			state.updatedLibraryAssets = updatedLibraryAssets;
		},

		resetLibraryAssets(state) {
			state.libraryAssets = {
				assetType: null,
				data: [],
				loaded: true,
			}
		}
	},

	actions: {
		async getLibraryAssets({commit}, payload) {
			commit("LIBRARY_ASSETS_REQUEST");

			if (payload.stationID) {
				return await AssetApi.stationsGraphql(payload).then(response => {
										 commit("LIBRARY_ASSETS_SUCCESS", {data: response.data.stationassets});
									 })
									 .catch(error => {
										 commit("LIBRARY_ASSETS_FAILURE");
										 console.log(error);
									 });
			}
			else {
				return await AssetApi.textSearch(payload)
									 .then(response => {
										 commit("LIBRARY_ASSETS_SUCCESS", {data: response.data.Assets});
									 })
									 .catch(error => {
										 commit("LIBRARY_ASSETS_FAILURE");
										 console.error(error);
									 })
			}
		},

		sortLibraryAssets({getters, commit}, {assetType, assetId}) {
			if (typeof assetId === "string") {
				commit("setUpdatedLibraryAssets", assetId);
				commit(
					"setUserPreferences",
					{libraryAssets: {assetType: assetType, assets: getters.getUpdatedLibraryAssets()}}
				);
			}
			else if (typeof assetId === "object") {
				commit("setLibraryAssetsPosition", assetId);
			}
		},

		setRecentlySearchedFromLocalStorage({commit, getters}) {
			getters.userPreferences("librarySearchedTerms")?.reverse().forEach(item => {
				commit("setRecentlySearched", item);
			});
		}
	}
};